import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { getMeta } from "@/api/product-dev";
import { ProjectDetail } from "@/pages/product-dev/ProjectDetail";
import { ProjectList } from "@/pages/product-dev/ProjectList";

/**
 * Контейнер раздела «Разработка продукции». Проект открывается ПО URL
 * (`/product-dev/:projectId`, вкладка — `?tab=`), а не локальным состоянием — так
 * ссылка на конкретный проект/вкладку рендерится напрямую (шаринг, кнопка «назад»,
 * прямой заход харнесса для скриншотов без прохода по меню).
 */
export function ProductDevPage(): React.ReactElement {
  const { projectId } = useParams<{ projectId?: string }>();
  const navigate = useNavigate();
  const meta = useQuery({ queryKey: ["pdev", "meta"], queryFn: getMeta, staleTime: Infinity });

  if (meta.isLoading || !meta.data) {
    return <div className="p-4 text-sm text-muted-foreground">Загрузка…</div>;
  }

  return projectId ? (
    <ProjectDetail
      projectId={projectId}
      meta={meta.data}
      onBack={() => navigate("/product-dev")}
    />
  ) : (
    <ProjectList meta={meta.data} onOpen={(id) => navigate(`/product-dev/${id}`)} />
  );
}
